import { Plan, PlanPurchaseExperienceMode } from '@dtx-company/true-common/src/types/Plan'
import { getPlanTypeDirection } from '@app/common/src/utils/getPlanTypeDirection'
import { isPilotPlanType } from '@app/common/src/utils/isPilotPlanType'

export const enum ConversionType {
  UPGRADE = 'upgrade',
  SWITCH = 'switch',
  DOWNGRADE = 'downgrade',
  CHANGE_ADDONS = 'change-addons',
  ACTIVATE_TRIAL = 'activate-trial',
  CHANGE_PAYMENT = 'change-payment'
}

export function getConversionType(
  currentPlan: Plan | undefined,
  selectedPlan: Plan | undefined,
  mode: PlanPurchaseExperienceMode | undefined
): ConversionType {
  if (mode === PlanPurchaseExperienceMode.PURCHASE_ADDONS) {
    return ConversionType.CHANGE_ADDONS
  }
  if (mode === PlanPurchaseExperienceMode.CHANGE_PAYMENT) {
    return ConversionType.CHANGE_PAYMENT
  }
  if (currentPlan && isPilotPlanType(currentPlan.type)) {
    // If they're on a PILOT plan then any purchaseable plan is considered an UPGRADE
    return ConversionType.UPGRADE
  }
  if (currentPlan?.type && selectedPlan?.type) {
    const planTypeDirection = getPlanTypeDirection(currentPlan.type, selectedPlan.type)
    if (planTypeDirection === 0) {
      if (currentPlan.interval === selectedPlan.interval) {
        // This assumes same plan type + same interval only happens when buying a trial
        // It can also happen if there's a special mode set, those must be checked beforehand
        return ConversionType.ACTIVATE_TRIAL
      }
      return ConversionType.SWITCH
    }
    if (planTypeDirection < 0) {
      return ConversionType.DOWNGRADE
    }
  }
  return ConversionType.UPGRADE
}
